import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'
import type {MilestoneRowMetadata$key} from './__generated__/MilestoneRowMetadata.graphql'
import styles from './RepositoryMilestone.module.css'
import {ProgressBar} from '@primer/react'
import {MilestoneRowMenu} from './MilestoneRowMenu'

type MilestoneRowMetadataProps = {
  milestone: MilestoneRowMetadata$key
}

export function MilestoneRowMetadata({milestone}: MilestoneRowMetadataProps) {
  const data = useFragment(
    graphql`
      fragment MilestoneRowMetadata on Milestone {
        ...MilestoneRowMenu
        progressPercentage
        openIssueCount
        closedIssueCount
      }
    `,
    milestone,
  )

  return (
    <div className={styles.listProgressSection}>
      <div className={styles.progress}>
        <ProgressBar
          progress={Math.floor(data.progressPercentage)}
          aria-hidden="true"
          data-testid="milestone-metadata-progress-bar"
          barSize="small"
          className={styles.progressBar}
        />
        <div className={styles.listMetadata}>
          <span>
            <span className={styles.progressPercentage}>{Math.floor(data.progressPercentage)}%</span> complete
          </span>
          <span data-testid="milestone-metadata-open-issues">
            <span className={styles.progressPercentage}>{data.openIssueCount}</span> open
          </span>
          <span data-testid="milestone-metadata-closed-issues">
            <span className={styles.progressPercentage}>{data.closedIssueCount}</span> closed
          </span>
        </div>
      </div>
      <MilestoneRowMenu milestone={data} />
    </div>
  )
}

try{ MilestoneRowMetadata.displayName ||= 'MilestoneRowMetadata' } catch {}